import { render, staticRenderFns } from "./dic-add-or-update.vue?vue&type=template&id=17b03f34&"
import script from "./dic-add-or-update.vue?vue&type=script&lang=js&"
export * from "./dic-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./dic-add-or-update.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports